export interface PendingBackInStock {
  variantId: string
  locale: string
  returnTo: string
  emailAddress?: string
}

export interface GuestBackInStockReminder {
  variantId: string
  locale: string
}

/** These markers describe a requested reminder, not delivery or account identity. */
export function parseGuestBackInStockReminders(raw: string | null): GuestBackInStockReminder[] {
  try {
    const value: unknown = JSON.parse(raw ?? '[]')
    if (!Array.isArray(value))
      return []
    return value.flatMap((item: unknown) => {
      if (!item || typeof item !== 'object')
        return []
      const reminder = item as Record<string, unknown>
      return typeof reminder.variantId === 'string' && reminder.variantId
        && typeof reminder.locale === 'string' && reminder.locale
        ? [{ variantId: reminder.variantId, locale: reminder.locale }]
        : []
    })
  }
  catch {
    return []
  }
}

/** Browser persistence carries an explicit opt-in, never an arbitrary redirect. */
export function parsePendingBackInStock(raw: string | null): PendingBackInStock | null {
  if (!raw)
    return null
  try {
    const value: unknown = JSON.parse(raw)
    if (!value || typeof value !== 'object')
      return null
    const pending = value as Record<string, unknown>
    if (typeof pending.variantId !== 'string' || !pending.variantId
      || typeof pending.locale !== 'string' || !pending.locale
      || typeof pending.returnTo !== 'string' || !pending.returnTo.startsWith('/')
      || pending.returnTo.startsWith('//') || pending.returnTo.includes('\\')
      || [...pending.returnTo].some(character => character.charCodeAt(0) < 32)
      || (pending.emailAddress !== undefined && typeof pending.emailAddress !== 'string')) {
      return null
    }
    return {
      variantId: pending.variantId,
      locale: pending.locale,
      returnTo: pending.returnTo,
      ...(pending.emailAddress ? { emailAddress: pending.emailAddress } : {}),
    }
  }
  catch {
    return null
  }
}
